/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerCreateMutationRequest,
  TelegramProductsUserControllerCreateMutationResponse,
  TelegramProductsUserControllerCreate401,
  TelegramProductsUserControllerCreate402,
  TelegramProductsUserControllerCreate404,
  TelegramProductsUserControllerCreate409,
} from '../../types/TelegramProductsUserControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserCreate } from '../../methods/telegramProductsUserCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserCreateMutationKey = () => [{ url: '/api/user/telegram/products' }] as const;

export type TelegramProductsUserCreateMutationKey = ReturnType<typeof telegramProductsUserCreateMutationKey>;

/**
 * {@link /api/user/telegram/products}
 */
export function useTelegramProductsUserCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerCreateMutationResponse,
      ResponseErrorConfig<
        | TelegramProductsUserControllerCreate401
        | TelegramProductsUserControllerCreate402
        | TelegramProductsUserControllerCreate404
        | TelegramProductsUserControllerCreate409
      >,
      { data: TelegramProductsUserControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsUserControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserCreateMutationKey();

  return useMutation<
    TelegramProductsUserControllerCreateMutationResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerCreate401
      | TelegramProductsUserControllerCreate402
      | TelegramProductsUserControllerCreate404
      | TelegramProductsUserControllerCreate409
    >,
    { data: TelegramProductsUserControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramProductsUserCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
